import styles from './Text.css';
import SuperSonic from './SuperSonic.gif'
import ShapeOfYou from './ShapeOfYou.gif'

export function Publication() {
  return (
<div class="body">
    <br/>
        <h2 id="centered">Graphic Design</h2>
                <hr/>

<div class="row" id="GalleryThree">

    <div class="column">

        <a href="/AdmittedStudentsDay"> <img alt="Admitted Students Day 2025" src="ASD.gif"/></a>
        <br/>
        <h4>
        <a href="/AdmittedStudentsDay">
            Admitted Students Day
                </a>, 2024-2025 
               <br/>
               <b>Client:</b> Minneapolis College of Art and Design.
    <br/>
               Identity System.
                Invitations. Tote Bag. Stickers. Signage.
                Social Media Graphics.
                E-mail & Website Gifs.
                </h4>
    </div>


</div>


<div class="row" id="GalleryThree">

<div class="column">
    
        <div class="column">

        <a href="/GrimReynolds"><img alt="Grim Reynolds" src="GrimReynolds3.png" /></a>

        <h4><a href="/GrimReynolds">Kim Reaper /  
                    Grim Reynolds</a>, 2025
        <br/>

        Printed newspaper featuring articles on Iowa 
        governor, Kim Reynolds. <br/>Concerning water 
        quality, education, 
        food assistance, and missing funds.

                        </h4>
    </div>

        
            <div class="column">

        <a href="/All52">
        <img alt="All 52" src="All52.gif" href="/ASD.js" /></a>
        <br/><h4>
        <a href="/All52">All52</a>, 2025
        <br/>Figma User Interface Design.
            </h4>
    </div> 


</div>






    <div class="column">

        <a href="/MajorMinorFair"><img alt="Major Minor Fair 2024" src="MMF_Mockup_Stanchion_02.jpg"/></a>

        <br/>
        <h4><a href="/MajorMinorFair">Major Minor Fair</a>
            , 2024
        <br/> 
        <b>Client:</b>  Minneapolis College of Art and Design.
        <br/>
        Wayfinding Posters. Web Gif.

        </h4>
    </div>



    <div class="column">

            <a href="/GYMcad"> <img alt="GYM-cad" src="GYMcad5.jpg"/></a>

        <br/><h4>
            <a href="/GYMcad">
            GYMcad
            </a>, 2024-2026
            <br/>
        <b>Fundraising and Brand Identity</b> for MCAD Gym Facilities
            <br/>
            Data Analysis Infographics, Poster, Flyer, and Logo.
            </h4>
    </div>

<div class="column">
    <div class="column">

     <img alt="" src="YPLS01.jpg" />
     

        <h4><a href="/">You Parked Like Shit</a>, 2025
        <br/>

        Book of Civillian Parking Tickets

                        </h4>
    </div>

    <div class="column">

            <div >
               <a href="/WeatherBody"> <img alt="Weather Body" src="WeatherBody15_1.jpg"/></a>
            </div>
            <h4>
                <a href="/WeatherBody">
   Weather Body
                </a>, 2025
               <br/>
               Poetry Anthology
                </h4>
        </div></div>



    <div class="column">

        <a href="/BookmarksForBrooklynPark"><img alt="Bookmarks" src="BookmarksPreview.png"/> </a>
         <br/>
        <h4>
        <a href="/BookmarksForBrooklynPark">
       Bookmarks For Brooklyn Park</a>, 2026<br/> 
        Minneapolis ICE Surge <b>Fundraiser</b>
         <br/>
         Oil-Based Ink, 
        Woodcut Relief prints on paper.
        Screen Print on paper.
        </h4>
    </div>

             <div class="column">
            <div >
               <a href="/NineteenRules"> <img alt="19 Rules of Type" src="19Rules18.jpg"/></a>
            </div>
            <br/><h4>
                <a href="/NineteenRules">
                19 Rules of Typography
                </a>, 2025
               <br/>
Instructional Typography Flip Book inspired by Rob Carter<br/><br/>
                Spiral-bound book.
                </h4>

        </div>

</div>



    <br/>
        <h2 id="centered">Motion Graphics</h2>
                <hr/>




<div class="row" id="GalleryThree">

        <div class="column">
           <a href="/MotionReel"> 
            <img  width="1920px" alt="Motion Reel 2024" src="MotionReel.gif" href="/MotionReel.js" /></a>
            <br/>           
            <h4>
            <a href="/MotionReel"> 
            Motion Reel
            </a>, 2024
            </h4>
        </div> 
</div>



<div class="row" id="GalleryThree">
    <div class="column">
                <a href="/ShapeOfYou">
                <img alt="Shape Of You" src={ShapeOfYou} href="/ShapeOfYou.js" />
                </a>

            <br/>
            <h4>
                <a href="/ShapeOfYou"> 
                Shape of You</a>, 2023
                </h4>
    </div>

    <div class="column">
                <a href="/SuperSonic">
                <img alt="Super Sonic" src={SuperSonic} href="/SuperSonic.js" />
                </a>

            <br/><h4>
                <a href="/SuperSonic">Super Sonic</a>, 2023
                </h4>
    </div>

    <div class="column">
                <a href="/Shoelaces">
                <img alt="Shoelaces" src="Shoelaces.gif" href="/Shoelaces.js" />
                </a>

            <br/>
            <h4>
                <a href="/Shoelaces"> 
                Shoelaces</a>, 2023
                <br/> Blender Animation.
                </h4>
    </div>
</div>

</div>   
                
        

  );
}


{/*

                */}